import styled from 'styled-components';
// import theme from '../theme';

const RootStyles = styled.div`
`;

export const Section = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  /* height: calc(60vw); */
  padding: 100px 40px;
  background-color: ${props => props.backgroundColor};
  h1 {
    text-shadow: none;
    margin-bottom: 40px;
    font-size: 3em;
    margin-bottom: .2em;
    line-height: 1.3em;
  }
  h2 {
    font-weight: bold;
    text-shadow: none;
    line-height: 1.5em;
  }
  .row {
    width: 960px;
  }
  .dork-subhead {
    font-size: 2em;
    margin-bottom: 40px;
  }
  em {
    opacity: 0.5;
  }
  &.dark {
    color: #fff;
    h2 {
      color: #ccc;
    }
  }
  &.triton {
    background: url(/assets/joey-nicotra-800212-unsplash.jpg) center center no-repeat;
    background-size: cover;
    height: calc(140vw);
    h1 {
      margin-top: calc(-60vh);
      margin-bottom: 20px;
    }
    @media (max-width: 990px) {
      h1 {
        margin-top: 0;
      }
    }
    p {
      margin: 20px 0;
      line-height: 24px;
    }
    span {
      line-height: .8em;
    }
    h1, h2 {
      text-shadow: 1px 1px 5px rgba(0,0,0,1);
    }
    .btn {
      background-color: #3E9F48;
      border: none;
      &:hover {
        background-color: #fff;
        color: #3E9F48;
      }
    }
  }
  .answer {
    line-height: 1.5em;
    margin-bottom: 40px;
  }
  &.the-set {
    .img {
      margin-bottom: 40px;
      background: center no-repeat;
      background-size: contain;
      height: calc(75vh);
      &.fork {
        background-image: url(/assets/set-fork.png);
      }
      &.knife {
        background-image: url(/assets/set-knife.png);
      }
      &.spoon {
        background-image: url(/assets/set-spoon.png);
      }    }
  }
  &.faqs {
    background: url(/assets/fork-quarter.png) center no-repeat #eee;
    .faq {
      background: white;
      box-shadow: 1px 1px 5px rgba(0,0,0,.25);
      border-radius: 5px;
      padding: 20px;
      margin-bottom: 20px;
      h2 {
        margin-bottom: 20px;
      }
    }
  }
  &.fork {
    padding: 200px 40px;
    background: url(/assets/fork.jpg) right center no-repeat #111111;
    background-size: contain;
    h2 {
      font-weight: normal !important;
    }
  }
  .mobile-only {
    visibility: hidden;
    display: none;
  }
  .btn {
    display: inline-block;
    border-radius: 40px;
    border: solid 1px #3E9F48;
    padding: 20px 40px;
    color: #fff;
    margin-top: 20px;
    font-size: 1.5em;
    &:hover {
      background: #3E9F48;
    }
  }
  @media (max-width: 990px) {
    height: auto;
    /* min-height: calc(90vh); */
    padding: 40px;
    .row {
      width: auto;
    }
    h1 {
      font-size: 2.2em;
      line-height: 1.1em;
      margin-bottom: 10px;
    }
    &.fork {
      padding: 40px;
      background-image: none;
    }
    .mobile-only {
      visibility: visible;
      display: block;
    }
  }
`;

export const Content = styled.div`
`;

export const Footer = styled.div`
  font-size: .8em;
  color: #999;
  align-self: flex-end;
  padding: 20px;
  background: #000;
  text-align: center;
`;

export default RootStyles;



// WEBPACK FOOTER //
// ./src/root/root_styles.js